
import SettleInFoot from '@/components/settleInFoot'

const Index = {
  name: 'settleInEnter',
  components: {
    SettleInFoot
  },
  mounted() {
    this.GetValidateCodeImg()
  },
  computed: {
  },
  data() {
    var validateChecked = this.validateChecked
    var validatePassCode = this.validatePassCode
    return {
      code_img: '',
      checked: false,
      form: {
        CompanyName: '', // 企业名称
        TaxNumber: '', //  
        Address: '', // 
        TelNumber: '', // 
        BankName: '',
        BankAccount: '',
        UserName: '',
        NickName: '',
        PhoneNumber: '',
        ValidateCode: '',
        MobileCode: '',
        Email: '', 
        BusinessLicenseURL: '',
        BusinessLicenseName: '',
        Referrer: '' // 推荐人
      },
      fileData: {
        FileName: '',
        Base64String: '',
        SysVersion: 'ivs'
      },
      Guid: '',
      loading: false,
      rules: {
        CompanyName: [
          {
            required: true,
            validator: async(rule, value, callback) => {
              if (!value) {
                callback(new Error('请输入企业名称'))
              }
              callback()
            },
            trigger: ['blur', 'change']
          }
        ],
        TaxNumber: [
          {
            required: true,
            validator: async(rule, value, callback) => {
              if (!value) {
                callback(new Error('请输入企业税号'))
              } else if(value.length != 18){
                callback(new Error('请输入正确的18位社会信用统一代码'))
              } else if(!((/^[^_IOZSVa-z\W]{2}\d{6}[^_IOZSVa-z\W]{10}$/g).test(value))){
                callback(new Error('请输入正确的社会信用统一代码'))
              }
              callback()
            },
            trigger: ['blur', 'change']
          }
        ],
        Address: [
          {
            required: true,
            validator: async(rule, value, callback) => {
              if (!value) {
                callback(new Error('请输入企业地址'))
              }
              callback()
            },
            trigger: ['blur', 'change']
          }
        ],
        TelNumber: [
          { 
            required: true,
            validator: async(rule, value, callback) => {
              if (!value) {
                callback(new Error('请输入电话号码'))
              } else if (!this.$minCommon.checkMobile(value) && !this.$minCommon.checkPhone(value)) {
                callback(new Error('请输入正确的电话号码'))
              }
              callback()
            }, 
            trigger: ['blur', 'change'] 
          }
        ],
        BankName:
          [{
            required: true,
            validator: async(rule, value, callback) => {
              if (!value) {
                callback(new Error('请输入开户银行'))
              }
              callback()
            },
            trigger: ['blur', 'change']
          }],
        BankAccount: [
          {
            required: true,
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
                const str = value.trim()
                if (!str) {
                  callback(new Error('请输入银行账户'))
                } else if(!this.$minCommon.checkBankCardSimple(str)) {
                  callback(new Error('请输入正确的银行账户'))
                }
                callback()
            }
          }          
        ],
        BusinessLicenseURL: [
          { required: true, message: '请上传营业执照', trigger: ['blur', 'change'] }
        ],
        UserName: [
          {
            required: true,
            trigger: ['blur', 'change'],
            validator: async (rule, value, callback) => {
                const str = value.trim()
                if (!str) {
                    callback(new Error('请输入用户名称'))
                } else {
                  const checkResult = await this.CheckRegisterIVSUserName(str)
                  if (checkResult.RetCode == '0') {
                    callback()
                  } else {
                    callback(new Error(checkResult.RetMsg))
                  }   
                }
            }
          }
        ],
        NickName: [
          {
            required: true,
            trigger: ['blur', 'change'],
            validator: async (rule, value, callback) => {
                const str = value.trim()
                if (!str) {
                    callback(new Error('请输入用户昵称'))
                } else {
                  callback()   
                }
            }
          }
        ],
        PhoneNumber: [
          { 
            required: true,
            validator: async(rule, value, callback) => {
              if (!value) {
                callback(new Error('请输入手机号码'))
              } else if (!this.$minCommon.checkMobile(value)) {
                callback(new Error('请输入正确的手机号码'))
              }
              callback()
            }, 
            trigger: ['blur', 'change'] 
          }
        ],
        ValidateCode: [
          { required: true, message: '请输入校验码', trigger: 'blur' },
          { validator: validatePassCode, trigger: ['blur', 'change'] }
        ],
        MobileCode: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error('请输入短信验证码'))
              } else if (value && value.length !== 6) {
                callback(new Error('请输入六位短信验证码'))
              }
              callback()
            },
            trigger: ['blur', 'change']
          }
        ],
         Email: [
          { 
            required: true,
            validator: async(rule, value, callback) => {
              if (!value) {
                callback(new Error('请输入电子邮件'))
              } else if (!this.$minCommon.checkEmail(value)) {
                callback(new Error('请输入正确的电子邮件'))
              }
              callback()
            }, 
            trigger: ['blur', 'change'] 
          }
        ],
        
        checked: [
          {
            validator: validateChecked,
            trigger: ['blur', 'change']
          }
        ]
      },

      CertificateType: null,
      codeNumLast: 0,
      statusCode: '',
      statusCode2: false,
      showStatus: false,
      isSubmit: false,
      isshowXieyi: false, // 协议弹窗
    }
  },
  methods: {
    _isMobile() {
      const flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag
    },
    login() {
      window.location.href = this.$invUrl
    },
    validateChecked(rule, value, callback) {
      if (!this.form.checked) {
        callback(new Error('请勾选协议'))
      }
      if (value) {
        callback()
      }
    },
    // 验证手机号
    validatePass(rule, value, callback) {
      if (!value) {
        callback(new Error('请输入手机号'))
      } else if (!this.$minCommon.checkMobile(value)) {
        callback(new Error('请输入正确的手机号'))
      }
      callback()
    },
    // 验证验证码
    validatePassCode(rule, value, callback) {
      if (!value) {
        callback(new Error('请输入验证码'))
      } else if (value && value.length !== 4) {
        callback(new Error('请输入正确的图形验证码'))
      }
      callback()
    },
    changeImg() {
      this.GetValidateCodeImg()
    },
    GetValidateCodeImg() {
      this.$api.GetValidateCodeImg().then(res => {
        if (res.RetCode !== '0') return this.$message.error(res.RetMsg)
        this.code_img = `data: image/jpg; base64, ${res.Message.Bytes}`
        this.Guid = res.Message.Guid
        const img = document.getElementById('code_img')
        img.onload = function() {
          const myCanvas = document.getElementById('myCanvas').getContext('2d')
          myCanvas.drawImage(img, 0, 0)
        }
      })
    },
    sureSubmit() {
      this.login()
      this.isSubmit = false
    },
    sureSubmitDoc() {
      this.isshowXieyi = false
    },
    viewdoc() {
      this.isshowXieyi = true
    },
    allin() {
      Promise.all([
        new Promise((resolve) => this.$refs.form.validate(resolve)),
        new Promise((resolve) => this.$refs.form2.validate(resolve)),
      ]).then(([valid1, valid2]) => {
        if (valid1 && valid2) {
          this.isSubmit = true
          this.loading = true
          // 表单提交
          this.$api.RegisterIVSApply(this.form).then(res => {
            this.loading = false
            // console.log(res)
            if (res.RetCode !== '0') {
              this.isSubmit = false
              return this.$message.error('错误：' + res.RetMsg)
            }
            this.showStatus = true
          }).catch(err => {
            this.isSubmit = false
            this.loading = false
            return this.$message.error('错误：' + err)
          })
        }    
      }).catch((error) => {
        console.log("验证失败", error);
      });

    },
    // 获取短信验证码
    SendPhoneValidataCode() {
      if (this.codeNumLast > 0) return
      if (!this.$minCommon.checkMobile(this.form.PhoneNumber)) {
        this.form.PhoneNumber = ' '
        setTimeout(() => {
          this.form.PhoneNumber = ''
        }, 20)
        return
      }
      if (this.form.ValidateCode.length !== 4) {
        this.form.ValidateCode = ' '
        setTimeout(() => {
          this.form.ValidateCode = ''
        }, 20)
        return
      }
      if (!this.Guid) {
        return this.$message.error('请重新获取图形验证码')
      }
      this.$api.SendPhoneValidataCode({
        telNumber: this.form.PhoneNumber,
        validateCode: this.form.ValidateCode,
        validCodeGuid: this.Guid
      }).then(async res => {
        if (res.RetCode !== '0') return this.$message.error('错误：' + res.RetMsg)
        this.$minCommon.setCountDown((num, timer) => {
          this.codeNumLast = num
        })
      })
    },

    // type: 1校验该手机号有没有注册过, 2用户名是否已存在 
    CheckRegisterIVSUserName(value){
      return new Promise((reslove, reject) => {
        this.$api.CheckRegisterIVSUserName({
          userName: value || ''
        }).then(res => {
          reslove(res)
        })
      })
    },
    uploadFile(params) {
      const _file = params.file
      const isLt2M = _file.size / 1024 / 1024 < 5
      this.$refs['uploadUrlRF'].clearFiles()

      if (!isLt2M) return this.$message.error('请上传5M以下的文件')

      // 通过 FormData 对象上传文件
      const formData = new FileReader()
      formData.readAsDataURL(_file)
      formData.onload = (e) => {
        this.fileData.FileName = _file.name
        this.fileData.Base64String = e.target.result
        this.$api.UploadRegistCertificate(this.fileData).then(res => {
          if (res.RetCode !== '0') return this.$message.error('错误：' + res.RetMsg)
          this.$message.success('上传成功')
          this.form.BusinessLicenseURL = res.Message // 营业执照地址
          this.form.BusinessLicenseName = _file.name || '' // 营业执照上传前的名字
        }).catch(err => {
          return this.$message.error('错误：' + err)
        })
      }
    },
    // 超出数量
    onExceed() {
      return this.$message.error('只能上传1张图片')
    },
  }
}
export default Index
